<template>
  <div class="">
    <!--开屏广告-->
    <advertisementModal ref="advertisementModal" @countEnd="advertiseEnd"></advertisementModal>
  </div>
</template>

<script>
import { postMettingDetail } from '@/models/common'
import { IsWx } from '@/utils/index.js'
import advertisementModal from '@/views/home/components/advertisement-modal'
export default {
  components: {
    advertisementModal
  },
  computed: {
    lanuage() {
      return this.$store.state.lanuage
    }
  },
  data() {
    return {
      roomNum: 0, // 房间号
      memberId: '', // 用户Id
      conventionId: -1,
      meetingDetail: {}, // 会议详情
      videoId: undefined // 默认指定的回放id，主要是针对当会议目录只有一条回放时，自动展示当前回放，否则只会展示会议，没有地方查看回放（只有一个直播或回放时不展示目录）
    }
  },
  async mounted() {
    const _this = this
    this.initWxBtns()
    await this.initContentDetail()
    if (this.$route.query.room) {
      // 当路由中带room，则按room查询
      this.roomNum = Number(this.$route.query.room)
    } else {
      // 当路由中不带room，则先按会议ID查询第一个直播间ID
    }
    if (this.$route.query.video_id) {
      // 当路由中带video_id，则按video_id查询
      this.videoId = Number(this.$route.query.video_id)
    }
    if (this.roomNum != -1) {
      let liveMeetIds = JSON.parse(sessionStorage.getItem('liveMeetIds') || '[]')
      if (this.meetingDetail.is_begin_image == 1 && !liveMeetIds.includes(this.$route.query.live_meeting_id)) {
        // 要显示开场图且未展示过
        liveMeetIds.push(this.$route.query.live_meeting_id)
        sessionStorage.setItem('liveMeetIds', JSON.stringify(liveMeetIds))
        this.advShow = true
        this.$refs.advertisementModal.showAdvertisement({
          advUrl: this.meetingDetail.begin_image_detail[0],
          advTime: this.meetingDetail.begin_image_time
        }) // 展示开屏广告
      } else {
        this.advShow = false
      }
      if (!_this.advShow) {
        _this.advertiseEnd()
      }
    }else {
      console.log("就跳转了？")
      this.$router.replace({
        path: '/auth',
        query: {
          union_id: this.$route.query.union_id,
          // memberId: this.memberId,
          room: this.roomNum,
          conventionId: this.$route.query.conventionId,
          openId: this.$route.query.openId,
          live_meeting_id: this.$route.query.live_meeting_id,
          siteId: this.$route.query.siteId,
          video_id: this.videoId // 回放
        }
      })
    }
  },
  methods: {
    // 当路由中没有room时，查询目录列表获取第一个room展示
    async initContentDetail() {
      // 如果路由中带memberId，则先保存至缓存中
      if (this.$route.query.memberId) {
        localStorage.setItem('loginItem', JSON.stringify({ userId: this.$route.query.memberId }))
        this.memberId = this.$route.query.memberId
      } else if (localStorage.getItem('loginItem')) {
        this.memberId = JSON.parse(localStorage.getItem('loginItem')).userId
      }
      const res = await postMettingDetail({
        live_metting_id: this.$route.query.live_meeting_id ? Number(this.$route.query.live_meeting_id) : null,
        member_id: this.memberId || '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9' // 游客ID
      })
      this.meetingDetail = res.data
      // 如果至少有一个流，则取第一个，否则房间默认-1
      if (this.meetingDetail.stream_list.length > 0) {
        this.roomNum = this.meetingDetail.stream_list[0].stream_id
      } else {
        this.roomNum = -1
      }
      // 如果只有一个直播流而且是回放，则指定回放id
      if (this.meetingDetail.stream_list.length == 1 && this.meetingDetail.stream_list[0].play_type == 'video') {
        this.videoId = this.meetingDetail.stream_list[0].id
      }
    },
    // 结束广告
    advertiseEnd() {
      const _this = this
      // if(IsWx() && this.lanuage == 'Chinese') {
      //   // 如果是微信里访问，切实中文环境
      //   const href = window.location.href.substring(0, window.location.href.indexOf('entry'))
      //   const redirectUrl = `${href}auth?live_meeting_id=${_this.$route.query.live_meeting_id}&room=${_this.roomNum}` + 
      //     (_this.$route.query.video_id ? `&video_id=${_this.$route.query.video_id}` : '') + 
      //     (_this.$route.query.conventionId ? `&conventionId=${_this.$route.query.conventionId}` : '') + 
      //     (_this.$route.query.siteId ? `&siteId=${_this.$route.query.siteId}` : '')
      //   const encodeUrl = encodeURIComponent(redirectUrl)
      //   window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.$store.state.appId}&redirect_uri=${encodeUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
      // } else {
        // 如果不是微信环境，则直接跳去直播页
        this.$router.replace({
          path: '/auth',
          query: {
            union_id: this.$route.query.union_id,
            // memberId: this.memberId,
            room: this.roomNum,
            conventionId: this.$route.query.conventionId,
            openId: this.$route.query.openId,
            live_meeting_id: this.$route.query.live_meeting_id,
            siteId: this.$route.query.siteId,
            video_id: this.videoId // 回放
          }
        })
      // }
    },
    // 初始化微信按钮
    initWxBtns() {
      // 禁用转发、复制链接等按钮
      wx.ready(function() {
        wx.hideAllNonBaseMenuItem()
      })
    }
  }
}
</script>

<style lang="less" scoped>

</style>